module.exports = __webpack_public_path__ + "static/media/btn_amazonb16b02d66f3a52ee585b8daaaf947be8.webp";